import convertEwsIdToRestId from './convertEwsIdToRestId';
import { getEmailLink } from './getEmailLinkForNote';
import LinkedEntity, {
    EMAIL_ENTITY_TYPE,
    DRAGGED_EMAIL_ENTITY_SUBTYPE,
} from '../store/schema/LinkedEntity';

export default function getLinkedEmailEntityForDroppedEmail(
    ewsitemId: string,
    subject: string
): LinkedEntity {
    return {
        Id: convertEwsIdToRestId(ewsitemId),
        WebLink: getEmailLink(ewsitemId),
        EntityType: EMAIL_ENTITY_TYPE,
        EntitySubtype: DRAGGED_EMAIL_ENTITY_SUBTYPE,
        DisplayName: subject,
        Preview: {
            RestId: convertEwsIdToRestId(ewsitemId),
        },
    };
}
